import type { PointOnMap } from '@cobliteam/common-types/src/geofenceV3';
import type { VehiclePassageListInputInfo } from '@cobliteam/common-types/src/vehiclePassageHistory';
import type { StateCreator } from 'zustand';
import type { MonitoringSlices } from '.';

import type { VehiclePassageApi } from '@cobliteam/api-lib';

const START = new Date(new Date().setDate(new Date().getDate() - 2));
const END = new Date(new Date().setDate(new Date().getDate() - 1));
const MIDNIGHT = '00:00';

const EMPTY_INPUT_INFO = {
  radius: 100,
  address: '',
  startDate: START,
  endDate: END,
  startTime: MIDNIGHT,
  endTime: MIDNIGHT,
  latLng: { lat: 0, lng: 0 },
  startDateAndTime: START,
  endDateAndTime: END,
};

interface VehiclePassageHistorySlice {
  vehiclePassageListInputInfo: VehiclePassageListInputInfo;
  infoLoading: boolean;
  clearInfo: () => void;
  setVehiclePassageListInputInfo: (vehiclePassageListInputInfo: VehiclePassageListInputInfo) => void;
  passageHistoryLocation: PointOnMap | undefined;
  setPassageHistoryLocation: (point: PointOnMap) => void;
  passageHistoryRange: number | undefined;
  setPassageHistoryRange: (value: number) => void;
  passageHistory: VehiclePassageApi | undefined;
  setPassageHistory: (passageHistory: VehiclePassageApi) => void;
}

type StateCreatorVehiclePassageHistory = StateCreator<MonitoringSlices, [['zustand/devtools', never]], [], VehiclePassageHistorySlice>;

const createVehiclePassageHistorySlice: StateCreatorVehiclePassageHistory = (set) => ({
  vehiclePassageListInputInfo: EMPTY_INPUT_INFO,
  infoLoading: false,
  setVehiclePassageListInputInfo(vehiclePassageListInputInfo) {
    set((state) => ({
      vehiclePassageListInputInfo: { ...state.vehiclePassageListInputInfo, ...vehiclePassageListInputInfo },
    }));
  },
  clearInfo: () =>
    set(() => ({
      vehiclePassageListInputInfo: EMPTY_INPUT_INFO,
      infoLoading: false,
      passageHistoryLocation: undefined,
      passageHistoryRange: undefined,
      passageHistory: undefined,
    })),
  passageHistoryLocation: undefined,
  setPassageHistoryLocation: (point: PointOnMap) =>
    set((state) => ({
      passageHistoryLocation: { ...state.passageHistoryLocation, ...point },
    })),
  passageHistoryRange: undefined,
  setPassageHistoryRange: (value: number) => set({ passageHistoryRange: value }),
  passageHistory: undefined,
  setPassageHistory: (passageHistory: VehiclePassageApi) => set({ passageHistory }),
});

export type { VehiclePassageHistorySlice };
export default createVehiclePassageHistorySlice;
